module.exports = __webpack_public_path__ + "img/slughorns_hourglass.837c770d.jpg";